"use strict";

angular.module("customer")
.factory("CartVendorService", function(
    $resource, $rootScope, $q, $http, UserService, moment, common, ModalService, gettextCatalog, FlashBag, appConfig
) {
    var fetching = false;

    function updateCartVendor(vendor) {
        if (!fetching) {
            fetching = true;
            var service = $resource(appConfig.API_SERVER + "/catalog/cart/vendors/:id/", {
                id: "@id"
            }, {
                get: {
                    method: "get",
                    ignoreLoadingBar: true
                },
                query: {
                    method: "get",
                    isArray: true,
                    ignoreLoadingBar: true
                },
                update: {
                    method: "PATCH",
                    ignoreLoadingBar: true
                }
            });
            var params = {
                vendor: vendor.id
            };
            var deferred = $q.defer();

            service.query(params, function(cart_vendor) {
                function updateFetchStateAndResolve(object) {
                    if (vendor.cancelStandingOrder) {
                        FlashBag.success(gettextCatalog.getString("The standing order was cancelled."), true);
                    }
                    vendor.cancelStandingOrder = false;
                    fetching = false;
                    $rootScope.UpdateCurrentNumbers();
                    deferred.resolve(object);
                }

                function updateFetchStateAndReject(response) {
                    vendor.cancelStandingOrder = false;
                    common.scrollToTop();
                    FlashBag.apiError(response);
                    fetching = false;
                    deferred.reject(response);
                }

                if (cart_vendor.length === 0) {
                    return UserService.isUserFetched().then(function onSuccess(user) {
                        cart_vendor = new service();
                        cart_vendor.vendor = vendor.id;
                        cart_vendor.po_number = vendor.po_number || null;
                        cart_vendor.delivery_date = vendor.delivery_date || null;
                        cart_vendor.note = vendor.note || null;
                        return cart_vendor.$save().then(updateFetchStateAndResolve, updateFetchStateAndReject);
                    });
                }
                else {
                    return service.get({
                        id: cart_vendor[0].id
                    }).$promise.then(function(cart_vendor) {
                        cart_vendor.po_number = vendor.po_number || null;
                        if (cart_vendor.delivery_date !== vendor.delivery_date && cart_vendor.standing_order) {
                            cart_vendor.standing_order = null;
                        }
                        cart_vendor.delivery_date = vendor.delivery_date || null;
                        cart_vendor.note = vendor.note || null;
                        cart_vendor.$update().then(updateFetchStateAndResolve, updateFetchStateAndReject);
                    });
                }
            });
            return deferred.promise;
        }
    }

    function getAPIResponseFlags(data) {
        if (typeof data == "object" && data != null && data.api_response_flags) {
            return data.api_response_flags;
        }
        return null;
    }

    return {
        updateCartVendor: updateCartVendor,
        deleteCartVendor: function(cartVendorId) {
            return $http.delete(appConfig.API_SERVER + "/catalog/cart/vendors/" + cartVendorId + "/");
        },
        updateDeliveryDateList: function(vendors) {
            if (vendors) {
                angular.forEach(vendors, function(vendor) {
                    if (vendor.allow_order_for_current_delivery_date && !vendor.is_cart_vendor_exists) {
                        if (!vendor.is_on_delivery_selected_by_default) {
                            vendor.delivery_date = "not-selected";
                            vendor.threshold_datetime = '';
                        }
                    }
                });
            }
        },
        isPaymentTermsError: function(data) {
            var APIResponseFlags = getAPIResponseFlags(data);
            return APIResponseFlags && (
                APIResponseFlags.is_credit_limit_error
                || APIResponseFlags.is_overdue_invoice_error
            );
        },
        isPreAuthorizedPaymentAgreementError: function(data) {
            var APIResponseFlags = getAPIResponseFlags(data);
            return (
                APIResponseFlags && APIResponseFlags.mandatory_pre_authorized_payment_method_errors
                && APIResponseFlags.mandatory_pre_authorized_payment_method_errors.length
            );
        },
        getFirstPreAuthorizedPaymentAgreementError: function(data) {
            var APIResponseFlags = getAPIResponseFlags(data);
            if (
                APIResponseFlags && APIResponseFlags.mandatory_pre_authorized_payment_method_errors
                && APIResponseFlags.mandatory_pre_authorized_payment_method_errors.length
            ) {
                return APIResponseFlags.mandatory_pre_authorized_payment_method_errors[0];
            }
        },
        isInventoryQuantityWarningError: function(data) {
            var APIResponseFlags = getAPIResponseFlags(data);
            return APIResponseFlags && APIResponseFlags.is_inventory_quantity_warning;
        },
        openInventoryWarningModal: function(warningData) {
            var deferred = $q.defer();
            var warningMessage = gettextCatalog.getPlural(
                warningData.length,
                "The product below is out of stock, do you still want to order it?",
                "The products below are out of stock, do you still want to order them?"
            );
            ModalService.showModal({
                templateUrl: require("core/confirmation/out-of-stock-warning-confirmation.modal.html"),
                controller: "Confirmation",
                controllerAs: "selector",
                inputs: {
                    $attrs: {
                        title: gettextCatalog.getString("Inventory warning"),
                        warnings: FlashBag.formatErrorList(warningData),
                        message: warningMessage
                    }
                }
            }).then(function(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function(result) {
                    if (result) {
                        deferred.resolve();
                    }
                    else {
                        deferred.reject();
                    }
                });
            });
            return deferred.promise;
        },
        showWarningMessages: function(messages) {
            var warningMessage = "";
            angular.forEach(messages, function(message) {
                warningMessage += message + "<br />";
            });

            if (warningMessage) {
                FlashBag.preformattedWarning(warningMessage, "");
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/cart/cart-vendor.service.js
// module id = 933
// module chunks = 0